<!-- git/truth-first-look/src/components/dashboard/RightSidebar.tsx root -->
<div class="space-y-4 py-3">
  <app-lovable-right-search></app-lovable-right-search>
  <app-lovable-who-to-follow-panel [users]="suggestedUsers"></app-lovable-who-to-follow-panel>
  <app-lovable-trending-topics-panel [topics]="trendingTopics"></app-lovable-trending-topics-panel>
  <app-lovable-right-rail-footer></app-lovable-right-rail-footer>
</div>
